import { ComponentProps } from "react";

import ListIcons from "./list-icons";

type IconProps = ComponentProps<"svg"> & {
  id: string;
};

export default function Icon(props: IconProps) {
  const { id, ...rest } = props;

  const currentSelectedIcon = ListIcons[id];
  return currentSelectedIcon ? currentSelectedIcon(rest) : null;
}
